// extracted by mini-css-extract-plugin
export var emptyState = "_5d-d";
export var statCard = "_5d-c";
export var table = "_5d-0";
export var tableCell = "_5d-4";
export var tableCellClickable = "_5d-5 _5d-4";
export var tableCellDefault = "_5d-6 _5d-4";
export var tableCellEmpty = "_5d-8";
export var tableCellWithValue = "_5d-7";
export var tableContainer = "_5d-e";
export var tableHeaderWeight = "_5d-1";
export var tableHeaderZone = "_5d-2";
export var tableRowHeader = "_5d-3";
export var viewModeButton = "_5d-9";
export var viewModeButtonActive = "_5d-a _5d-9";
export var viewModeButtonInactive = "_5d-b _5d-9";